// @ts-strict-ignore
import { AuthService } from 'rainbow-web-sdk/services/core/auth.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { I18nService } from 'rainbow-web-sdk/services/core/i18n.service';
import { ErrorHelperService } from 'rainbow-web-sdk/services/utilities/errorHelper.service';
import { Service } from 'rainbow-web-sdk/services/service';

export const COUNTRY_SVC = 'CountryService';

export interface Country {
    name: string, "alpha-2": string, "alpha-3": string, "country-code"?: string, default?: boolean
};

export class CountryService extends Service {

    private portalURL: string = null;
    private errorHelperService: ErrorHelperService = ErrorHelperService.getInstance();
    private authService: AuthService = AuthService.getInstance();
    private logger: LoggerService = LoggerService.getInstance();
    private i18n: I18nService = I18nService.getInstance();

    /**
     * List of data center locations, grouped by geographical regions
     */
    public datacenters: any[] = [
        { "name": "France", "alpha-3": "FRA", "alpha-2": "FR", "region": "Europe" },
        { "name": "Germany", "alpha-3": "DEU", "alpha-2": "DE", "region": "Europe" },
        { "name": "Canada", "alpha-3": "CAN", "alpha-2": "CA", "region": "America" },
        { "name": "Singapore", "alpha-3": "SGP", "alpha-2": "SG", "region": "Asia-Pacific" }
    ];

    /**
     * List of countries (obsolete)
     */
    public countries: Country[] = [
        { "name": "Australia", "alpha-3": "AUS", "country-code": "036", "alpha-2": "AU" },
        { "name": "Austria", "alpha-3": "AUT", "country-code": "040", "alpha-2": "AT" },
        { "name": "Belgium", "alpha-3": "BEL", "country-code": "056", "alpha-2": "BE" },
        { "name": "Brazil", "alpha-3": "BRA", "country-code": "076", "alpha-2": "BR" },
        { "name": "Canada", "alpha-3": "CAN", "country-code": "124", "alpha-2": "CA" },
        { "name": "China", "alpha-3": "CHN", "country-code": "156", "alpha-2": "CN" },
        { "name": "Czech Republic", "alpha-3": "CZE", "country-code": "203", "alpha-2": "CZ" },
        { "name": "Denmark", "alpha-3": "DNK", "country-code": "208", "alpha-2": "DK" },
        { "name": "Finland", "alpha-3": "FIN", "country-code": "246", "alpha-2": "FI" },
        { "name": "France", "alpha-3": "FRA", "country-code": "250", "default": true, "alpha-2": "FR" },
        { "name": "Germany", "alpha-3": "DEU", "country-code": "276", "alpha-2": "DE" },
        { "name": "Hong Kong", "alpha-3": "HKG", "country-code": "344", "alpha-2": "HK" },
        { "name": "Ireland", "alpha-3": "IRL", "country-code": "372", "alpha-2": "IE" },
        { "name": "Israel", "alpha-3": "ISR", "country-code": "376", "alpha-2": "IL" },
        { "name": "Italy", "alpha-3": "ITA", "country-code": "380", "alpha-2": "IT" },
        { "name": "Mexico", "alpha-3": "MEX", "country-code": "484", "alpha-2": "MX" },
        { "name": "Netherlands", "alpha-3": "NLD", "country-code": "528", "alpha-2": "NL" },
        { "name": "Norway", "alpha-3": "NOR", "country-code": "578", "alpha-2": "NO" },
        { "name": "Poland", "alpha-3": "POL", "country-code": "616", "alpha-2": "PL" },
        { "name": "Portugal", "alpha-3": "PRT", "country-code": "620", "alpha-2": "PT" },
        { "name": "Russia", "alpha-3": "RUS", "country-code": "643", "alpha-2": "RU" },
        { "name": "South Africa", "alpha-3": "ZAF", "country-code": "710", "alpha-2": "ZA" },
        { "name": "South Korea", "alpha-3": "KOR", "country-code": "410", "alpha-2": "KR" },
        { "name": "Spain", "alpha-3": "ESP", "country-code": "724", "alpha-2": "ES" },
        { "name": "Sweden", "alpha-3": "SWE", "country-code": "752", "alpha-2": "SE" },
        { "name": "Switzerland", "alpha-3": "CHE", "country-code": "756", "alpha-2": "CH" },
        { "name": "Taiwan", "alpha-3": "TWN", "country-code": "158", "alpha-2": "TW" },
        { "name": "Turkey", "alpha-3": "TUR", "country-code": "792", "alpha-2": "TR" },
        { "name": "United Kingdom", "alpha-3": "GBR", "country-code": "826", "alpha-2": "GB" },
        { "name": "United States of America", "alpha-3": "USA", "country-code": "840", "alpha-2": "US" },
        { "name": "Afghanistan", "alpha-3": "AFG", "country-code": "004", "alpha-2": "AF" },
        { "name": "Albania", "alpha-3": "ALB", "country-code": "008", "alpha-2": "AL" },
        { "name": "Algeria", "alpha-3": "DZA", "country-code": "012", "alpha-2": "DZ" },
        { "name": "Andorra", "alpha-3": "AND", "country-code": "020", "alpha-2": "AD" },
        { "name": "Angola", "alpha-3": "AGO", "country-code": "024", "alpha-2": "AO" },
        { "name": "Anguilla", "alpha-3": "AIA", "country-code": "660", "alpha-2": "AI" },
        { "name": "Antigua and Barbuda", "alpha-3": "ATG", "country-code": "028", "alpha-2": "AG" },
        { "name": "Argentina", "alpha-3": "ARG", "country-code": "032", "alpha-2": "AR" },
        { "name": "Armenia", "alpha-3": "ARM", "country-code": "051", "alpha-2": "AM" },
        { "name": "Aruba", "alpha-3": "ABW", "country-code": "533", "alpha-2": "AW" },
        { "name": "Azerbaijan", "alpha-3": "AZE", "country-code": "031", "alpha-2": "AZ" },
        { "name": "Bahamas", "alpha-3": "BHS", "country-code": "044", "alpha-2": "BS" },
        { "name": "Bahrain", "alpha-3": "BHR", "country-code": "048", "alpha-2": "BH" },
        { "name": "Bangladesh", "alpha-3": "BGD", "country-code": "050", "alpha-2": "BD" },
        { "name": "Barbados", "alpha-3": "BRB", "country-code": "052", "alpha-2": "BB" },
        { "name": "Belarus", "alpha-3": "BLR", "country-code": "112", "alpha-2": "BY" },
        { "name": "Belize", "alpha-3": "BLZ", "country-code": "084", "alpha-2": "BZ" },
        { "name": "Benin", "alpha-3": "BEN", "country-code": "204", "alpha-2": "BJ" },
        { "name": "Bermuda", "alpha-3": "BMU", "country-code": "060", "alpha-2": "BM" },
        { "name": "Bhutan", "alpha-3": "BTN", "country-code": "064", "alpha-2": "BT" },
        { "name": "Bolivia", "alpha-3": "BOL", "country-code": "068", "alpha-2": "BO" },
        { "name": "Bosnia and Herzegovina", "alpha-3": "BIH", "country-code": "070", "alpha-2": "BA" },
        { "name": "Botswana", "alpha-3": "BWA", "country-code": "072", "alpha-2": "BW" },
        { "name": "British Virgin Islands", "alpha-3": "VGB", "country-code": "092", "alpha-2": "VG" },
        { "name": "Brunei Darussalam", "alpha-3": "BRN", "country-code": "096", "alpha-2": "BN" },
        { "name": "Bulgaria", "alpha-3": "BGR", "country-code": "100", "alpha-2": "BG" },
        { "name": "Burkina Faso", "alpha-3": "BFA", "country-code": "854", "alpha-2": "BF" },
        { "name": "Burundi", "alpha-3": "BDI", "country-code": "108", "alpha-2": "BI" },
        { "name": "Cambodia", "alpha-3": "KHM", "country-code": "116", "alpha-2": "KH" },
        { "name": "Cameroon", "alpha-3": "CMR", "country-code": "120", "alpha-2": "CM" },
        { "name": "Cape Verde", "alpha-3": "CPV", "country-code": "132", "alpha-2": "CV" },
        { "name": "Cayman Islands", "alpha-3": "CYM", "country-code": "136", "alpha-2": "KY" },
        { "name": "Central African Republic", "alpha-3": "CAF", "country-code": "140", "alpha-2": "CF" },
        { "name": "Chad", "alpha-3": "TCD", "country-code": "148", "alpha-2": "TD" },
        { "name": "Chile", "alpha-3": "CHL", "country-code": "152", "alpha-2": "CL" },
        { "name": "Colombia", "alpha-3": "COL", "country-code": "170", "alpha-2": "CO" },
        { "name": "Comoros", "alpha-3": "COM", "country-code": "174", "alpha-2": "KM" },
        { "name": "Congo", "alpha-3": "COG", "country-code": "178", "alpha-2": "CG" },
        { "name": "Congo, Democratic Republic of", "alpha-3": "COD", "country-code": "180", "alpha-2": "CD" },
        { "name": "Costa Rica", "alpha-3": "CRI", "country-code": "188", "alpha-2": "CR" },
        { "name": "Ivory Coast", "alpha-3": "CIV", "country-code": "384", "alpha-2": "CI" },
        { "name": "Croatia", "alpha-3": "HRV", "country-code": "191", "alpha-2": "HR" },
        { "name": "Cyprus", "alpha-3": "CYP", "country-code": "196", "alpha-2": "CY" },
        { "name": "Djibouti", "alpha-3": "DJI", "country-code": "262", "alpha-2": "DJ" },
        { "name": "Dominica", "alpha-3": "DMA", "country-code": "212", "alpha-2": "DM" },
        { "name": "Dominican Republic", "alpha-3": "DOM", "country-code": "214", "alpha-2": "DO" },
        { "name": "Ecuador", "alpha-3": "ECU", "country-code": "218", "alpha-2": "EC" },
        { "name": "El Salvador", "alpha-3": "SLV", "country-code": "222", "alpha-2": "SV" },
        { "name": "Egypt", "alpha-3": "EGY", "country-code": "818", "alpha-2": "EG" },
        { "name": "Eritrea", "alpha-3": "ERI", "country-code": "232", "alpha-2": "ER" },
        { "name": "Estonia", "alpha-3": "EST", "country-code": "233", "alpha-2": "EE" },
        { "name": "Ethiopia", "alpha-3": "ETH", "country-code": "231", "alpha-2": "ET" },
        { "name": "Fiji", "alpha-3": "FJI", "country-code": "242", "alpha-2": "FJ" },
        { "name": "French Guiana", "alpha-3": "GUF", "country-code": "254", "alpha-2": "GF" },
        { "name": "French Polynesia", "alpha-3": "PYF", "country-code": "258", "alpha-2": "PF" },
        { "name": "Gabon", "alpha-3": "GAB", "country-code": "266", "alpha-2": "GA" },
        { "name": "Gambia", "alpha-3": "GMB", "country-code": "270", "alpha-2": "GM" },
        { "name": "Georgia", "alpha-3": "GEO", "country-code": "268", "alpha-2": "GE" },
        { "name": "Ghana", "alpha-3": "GHA", "country-code": "288", "alpha-2": "GH" },
        { "name": "Greece", "alpha-3": "GRC", "country-code": "300", "alpha-2": "GR" },
        { "name": "Grenada", "alpha-3": "GRD", "country-code": "308", "alpha-2": "GD" },
        { "name": "Guadeloupe", "alpha-3": "GLP", "country-code": "312", "alpha-2": "GP" },
        { "name": "Guatemala", "alpha-3": "GTM", "country-code": "320", "alpha-2": "GT" },
        { "name": "Guinea", "alpha-3": "GIN", "country-code": "324", "alpha-2": "GN" },
        { "name": "Guyana", "alpha-3": "GUY", "country-code": "328", "alpha-2": "GY" },
        { "name": "Haiti", "alpha-3": "HTI", "country-code": "332", "alpha-2": "HT" },
        { "name": "Honduras", "alpha-3": "HND", "country-code": "340", "alpha-2": "HN" },
        { "name": "Hungary", "alpha-3": "HUN", "country-code": "348", "alpha-2": "HU" },
        { "name": "Iceland", "alpha-3": "ISL", "country-code": "352", "alpha-2": "IS" },
        { "name": "India", "alpha-3": "IND", "country-code": "356", "alpha-2": "IN" },
        { "name": "Indonesia", "alpha-3": "IDN", "country-code": "360", "alpha-2": "ID" },
        { "name": "Iraq", "alpha-3": "IRQ", "country-code": "368", "alpha-2": "IQ" },
        { "name": "Jamaica", "alpha-3": "JAM", "country-code": "388", "alpha-2": "JM" },
        { "name": "Japan", "alpha-3": "JPN", "country-code": "392", "alpha-2": "JP" },
        { "name": "Jordan", "alpha-3": "JOR", "country-code": "400", "alpha-2": "JO" },
        { "name": "Kazakhstan", "alpha-3": "KAZ", "country-code": "398", "alpha-2": "KZ" },
        { "name": "Kenya", "alpha-3": "KEN", "country-code": "404", "alpha-2": "KE" },
        { "name": "Kuwait", "alpha-3": "KWT", "country-code": "414", "alpha-2": "KW" },
        { "name": "Kyrgyzstan", "alpha-3": "KGZ", "country-code": "417", "alpha-2": "KG" },
        { "name": "Latvia", "alpha-3": "LVA", "country-code": "428", "alpha-2": "LV" },
        { "name": "Lebanon", "alpha-3": "LBN", "country-code": "422", "alpha-2": "LB" },
        { "name": "Lesotho", "alpha-3": "LSO", "country-code": "426", "alpha-2": "LS" },
        { "name": "Liberia", "alpha-3": "LBR", "country-code": "430", "alpha-2": "LR" },
        { "name": "Libya", "alpha-3": "LBY", "country-code": "434", "alpha-2": "LY" },
        { "name": "Liechtenstein", "alpha-3": "LIE", "country-code": "438", "alpha-2": "LI" },
        { "name": "Lithuania", "alpha-3": "LTU", "country-code": "440", "alpha-2": "LT" },
        { "name": "Luxembourg", "alpha-3": "LUX", "country-code": "442", "alpha-2": "LU" },
        { "name": "Macao", "alpha-3": "MAC", "country-code": "446", "alpha-2": "MO" },
        { "name": "Macedonia", "alpha-3": "MKD", "country-code": "807", "alpha-2": "MK" },
        { "name": "Madagascar", "alpha-3": "MDG", "country-code": "450", "alpha-2": "MG" },
        { "name": "Malawi", "alpha-3": "MWI", "country-code": "454", "alpha-2": "MW" },
        { "name": "Malaysia", "alpha-3": "MYS", "country-code": "458", "alpha-2": "MY" },
        { "name": "Maldives", "alpha-3": "MDV", "country-code": "462", "alpha-2": "MV" },
        { "name": "Mali", "alpha-3": "MLI", "country-code": "466", "alpha-2": "ML" },
        { "name": "Malta", "alpha-3": "MLT", "country-code": "470", "alpha-2": "MT" },
        { "name": "Mauritius", "alpha-3": "MUS", "country-code": "480", "alpha-2": "MU" },
        { "name": "Mayotte", "alpha-3": "MYT", "country-code": "175", "alpha-2": "YT" },
        { "name": "Moldova", "alpha-3": "MDA", "country-code": "498", "alpha-2": "MD" },
        { "name": "Monaco", "alpha-3": "MCO", "country-code": "492", "alpha-2": "MC" },
        { "name": "Mongolia", "alpha-3": "MNG", "country-code": "496", "alpha-2": "MN" },
        { "name": "Montenegro", "alpha-3": "MNE", "country-code": "499", "alpha-2": "ME" },
        { "name": "Montserrat", "alpha-3": "MSR", "country-code": "500", "alpha-2": "MS" },
        { "name": "Morocco", "alpha-3": "MAR", "country-code": "504", "alpha-2": "MA" },
        { "name": "Mozambique", "alpha-3": "MOZ", "country-code": "508", "alpha-2": "MZ" },
        { "name": "Myanmar", "alpha-3": "MMR", "country-code": "104", "alpha-2": "MM" },
        { "name": "Namibia", "alpha-3": "NAM", "country-code": "516", "alpha-2": "NA" },
        { "name": "Nepal", "alpha-3": "NPL", "country-code": "524", "alpha-2": "NP" },
        { "name": "New Zealand", "alpha-3": "NZL", "country-code": "554", "alpha-2": "NZ" },
        { "name": "Nicaragua", "alpha-3": "NIC", "country-code": "558", "alpha-2": "NI" },
        { "name": "Niger", "alpha-3": "NER", "country-code": "562", "alpha-2": "NE" },
        { "name": "Nigeria", "alpha-3": "NGA", "country-code": "566", "alpha-2": "NG" },
        { "name": "Oman", "alpha-3": "OMN", "country-code": "512", "alpha-2": "OM" },
        { "name": "Pakistan", "alpha-3": "PAK", "country-code": "586", "alpha-2": "PK" },
        { "name": "Palestine", "alpha-3": "PSE", "country-code": "275", "alpha-2": "PS" },
        { "name": "Panama", "alpha-3": "PAN", "country-code": "591", "alpha-2": "PA" },
        { "name": "Paraguay", "alpha-3": "PRY", "country-code": "600", "alpha-2": "PY" },
        { "name": "Peru", "alpha-3": "PER", "country-code": "604", "alpha-2": "PE" },
        { "name": "Philippines", "alpha-3": "PHL", "country-code": "608", "alpha-2": "PH" },
        { "name": "Puerto Rico", "alpha-3": "PRI", "country-code": "630", "alpha-2": "PR" },
        { "name": "Qatar", "alpha-3": "QAT", "country-code": "634", "alpha-2": "QA" },
        { "name": "Romania", "alpha-3": "ROU", "country-code": "642", "alpha-2": "RO" },
        { "name": "Rwanda", "alpha-3": "RWA", "country-code": "646", "alpha-2": "RW" },
        { "name": "Saint Kitts and Nevis", "alpha-3": "KNA", "country-code": "659", "alpha-2": "KN" },
        { "name": "Saint Lucia", "alpha-3": "LCA", "country-code": "662", "alpha-2": "LC" },
        { "name": "Saint Vincent and the Grenadines", "alpha-3": "VCT", "country-code": "670", "alpha-2": "VC" },
        { "name": "Saudi Arabia", "alpha-3": "SAU", "country-code": "682", "alpha-2": "SA" },
        { "name": "Senegal", "alpha-3": "SEN", "country-code": "686", "alpha-2": "SN" },
        { "name": "Serbia", "alpha-3": "SRB", "country-code": "688", "alpha-2": "RS" },
        { "name": "Sierra Leone", "alpha-3": "SLE", "country-code": "694", "alpha-2": "SL" },
        { "name": "Singapore", "alpha-3": "SGP", "country-code": "702", "alpha-2": "SG" },
        { "name": "Slovakia", "alpha-3": "SVK", "country-code": "703", "alpha-2": "SK" },
        { "name": "Slovenia", "alpha-3": "SVN", "country-code": "705", "alpha-2": "SI" },
        { "name": "South Sudan", "alpha-3": "SSD", "country-code": "728", "alpha-2": "SS" },
        { "name": "Sri Lanka", "alpha-3": "LKA", "country-code": "144", "alpha-2": "LK" },
        { "name": "Sudan", "alpha-3": "SDN", "country-code": "729", "alpha-2": "SD" },
        { "name": "Swaziland", "alpha-3": "SWZ", "country-code": "748", "alpha-2": "SZ" },
        { "name": "Tajikistan", "alpha-3": "TJK", "country-code": "762", "alpha-2": "TJ" },
        { "name": "Tanzania", "alpha-3": "TZA", "country-code": "834", "alpha-2": "TZ" },
        { "name": "Thailand", "alpha-3": "THA", "country-code": "764", "alpha-2": "TH" },
        { "name": "Togo", "alpha-3": "TGO", "country-code": "768", "alpha-2": "TG" },
        { "name": "Trinidad and Tobago", "alpha-3": "TTO", "country-code": "780", "alpha-2": "TT" },
        { "name": "Tunisia", "alpha-3": "TUN", "country-code": "788", "alpha-2": "TN" },
        { "name": "Turkmenistan", "alpha-3": "TKM", "country-code": "795", "alpha-2": "TM" },
        { "name": "Turks and Caicos Islands", "alpha-3": "TCA", "country-code": "796", "alpha-2": "TC" },
        { "name": "Uganda", "alpha-3": "UGA", "country-code": "800", "alpha-2": "UG" },
        { "name": "Ukraine", "alpha-3": "UKR", "country-code": "804", "alpha-2": "UA" },
        { "name": "United Arab Emirates", "alpha-3": "ARE", "country-code": "784", "alpha-2": "AE" },
        { "name": "Virgin Islands, US", "alpha-3": "VIR", "country-code": "850", "alpha-2": "VI" },
        { "name": "Uruguay", "alpha-3": "URY", "country-code": "858", "alpha-2": "UY" },
        { "name": "Uzbekistan", "alpha-3": "UZB", "country-code": "860", "alpha-2": "UZ" },
        { "name": "Venezuela", "alpha-3": "VEN", "country-code": "862", "alpha-2": "VE" },
        { "name": "Vietnam", "alpha-3": "VNM", "country-code": "704", "alpha-2": "VN" },
        { "name": "Zambia", "alpha-3": "ZMB", "country-code": "894", "alpha-2": "ZM" },
        { "name": "Zimbabwe", "alpha-3": "ZWE", "country-code": "716", "alpha-2": "ZW" }];

    /** Alphabetical list of Canadian states **/
    public statesOfCanada: any = {
        AB: "Alberta",
        BC: "British Columbia",
        MB: "Manitoba",
        NB: "New Brunswick",
        NL: "Newfoundland and Labrador",
        NS: "Nova Scotia",
        NT: "Northwest Territories",
        NU: "Nunavut",
        ON: "Ontario",
        PE: "Prince Edward Island",
        QC: "Quebec",
        SK: "Saskatchewan",
        YT: "Yukon"
    };

    /** Alphabetical list of US states **/
    public statesOfAmerica: any = {
        AL: "Alabama",
        AK: "Alaska",
        AZ: "Arizona",
        AR: "Arkansas",
        AA: "Armed Forces America",
        AE: "Armed Forces",
        AP: "Armed Forces Pacific",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        FL: "Florida",
        GA: "Georgia",
        GU: "Guam",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        PR: "Puerto Rico",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VI: "Virgin Islands",
        VA: "Virginia",
        WA: "Washington",
        DC: "Washington DC",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming"
    };

    /*
    * List of country code to international prefix mappings
    * modified 25/10/2024
    *
    * New countries IO, CW, GG, JE, PS, RE, SX, SS, SJ, EH
    *
    * Modified countries :
    * DO old 1809 new 18
    * IM old 44 new 441624
    * MF old 1599 new 590
    * PN old 870 new 64
    * VA old 39 new 379
    * XK old 381 new 383
    */
    public countryToInternationalCallingCodeMapping: any = {
        'AD': '376',
        'AE': '971',
        'AF': '93',
        'AG': '1268',
        'AI': '1264',
        'AL': '355',
        'AM': '374',
        'AN': '599',
        'AO': '244',
        'AQ': '672',
        'AR': '54',
        'AS': '1684',
        'AT': '43',
        'AU': '61',
        'AW': '297',
        'AZ': '994',
        'BA': '387',
        'BB': '1246',
        'BD': '880',
        'BE': '32',
        'BF': '226',
        'BG': '359',
        'BH': '973',
        'BI': '257',
        'BJ': '229',
        'BL': '590',
        'BM': '1441',
        'BN': '673',
        'BO': '591',
        'BR': '55',
        'BS': '1242',
        'BT': '975',
        'BW': '267',
        'BY': '375',
        'BZ': '501',
        'CA': '1',
        'CC': '61',
        'CD': '243',
        'CF': '236',
        'CG': '242',
        'CH': '41',
        'CI': '225',
        'CK': '682',
        'CL': '56',
        'CM': '237',
        'CN': '86',
        'CO': '57',
        'CR': '506',
        'CU': '53',
        'CV': '238',
        'CW': '599',
        'CX': '61',
        'CY': '357',
        'CZ': '420',
        'DE': '49',
        'DJ': '253',
        'DK': '45',
        'DM': '1767',
        'DO': '18',
        'DZ': '213',
        'EC': '593',
        'EE': '372',
        'EG': '20',
        'EH': '212',
        'ER': '291',
        'ES': '34',
        'ET': '251',
        'FI': '358',
        'FJ': '679',
        'FK': '500',
        'FM': '691',
        'FO': '298',
        'FR': '33',
        'GA': '241',
        'GB': '44',
        'GD': '1473',
        'GE': '995',
        'GG': '441481',
        'GH': '233',
        'GI': '350',
        'GL': '299',
        'GM': '220',
        'GN': '224',
        'GQ': '240',
        'GR': '30',
        'GT': '502',
        'GU': '1671',
        'GW': '245',
        'GY': '592',
        'HK': '852',
        'HN': '504',
        'HR': '385',
        'HT': '509',
        'HU': '36',
        'ID': '62',
        'IE': '353',
        'IL': '972',
        'IM': '441624',
        'IN': '91',
        'IO': '246',
        'IQ': '964',
        'IR': '98',
        'IS': '354',
        'IT': '39',
        'JE': '441534',
        'JM': '1876',
        'JO': '962',
        'JP': '81',
        'KE': '254',
        'KG': '996',
        'KH': '855',
        'KI': '686',
        'KM': '269',
        'KN': '1869',
        'KP': '850',
        'KR': '82',
        'KW': '965',
        'KY': '1345',
        'KZ': '7',
        'LA': '856',
        'LB': '961',
        'LC': '1758',
        'LI': '423',
        'LK': '94',
        'LR': '231',
        'LS': '266',
        'LT': '370',
        'LU': '352',
        'LV': '371',
        'LY': '218',
        'MA': '212',
        'MC': '377',
        'MD': '373',
        'ME': '382',
        'MF': '590',
        'MG': '261',
        'MH': '692',
        'MK': '389',
        'ML': '223',
        'MM': '95',
        'MN': '976',
        'MO': '853',
        'MP': '1670',
        'MR': '222',
        'MS': '1664',
        'MT': '356',
        'MU': '230',
        'MV': '960',
        'MW': '265',
        'MX': '52',
        'MY': '60',
        'MZ': '258',
        'NA': '264',
        'NC': '687',
        'NE': '227',
        'NG': '234',
        'NI': '505',
        'NL': '31',
        'NO': '47',
        'NP': '977',
        'NR': '674',
        'NU': '683',
        'NZ': '64',
        'OM': '968',
        'PA': '507',
        'PE': '51',
        'PF': '689',
        'PG': '675',
        'PH': '63',
        'PK': '92',
        'PL': '48',
        'PM': '508',
        'PN': '64',
        'PR': '1',
        'PS': '970',
        'PT': '351',
        'PW': '680',
        'PY': '595',
        'QA': '974',
        'RE': '262',
        'RO': '40',
        'RS': '381',
        'RU': '7',
        'RW': '250',
        'SA': '966',
        'SB': '677',
        'SC': '248',
        'SD': '249',
        'SE': '46',
        'SG': '65',
        'SH': '290',
        'SI': '386',
        'SJ': '47',
        'SK': '421',
        'SL': '232',
        'SM': '378',
        'SN': '221',
        'SO': '252',
        'SR': '597',
        'SS': '211',
        'ST': '239',
        'SV': '503',
        'SX': '1721',
        'SY': '963',
        'SZ': '268',
        'TC': '1649',
        'TD': '235',
        'TG': '228',
        'TH': '66',
        'TJ': '992',
        'TK': '690',
        'TL': '670',
        'TM': '993',
        'TN': '216',
        'TO': '676',
        'TR': '90',
        'TT': '1868',
        'TV': '688',
        'TW': '886',
        'TZ': '255',
        'UA': '380',
        'UG': '256',
        'US': '1',
        'UY': '598',
        'UZ': '998',
        'VA': '379',
        'VC': '1784',
        'VE': '58',
        'VG': '1284',
        'VI': '1340',
        'VN': '84',
        'VU': '678',
        'WF': '681',
        'WS': '685',
        'XK': '383',
        'YE': '967',
        'YT': '262',
        'ZA': '27',
        'ZM': '260',
        'ZW': '263'
    };

    /*
     * Upstream source: https://wiki.openstreetmap.org/wiki/Nominatim/Country_Codes
    */
    public countryToLanguageMapping: any = {
        'ad': 'ca',
        'ae': 'ar',
        'af': 'fa,ps',
        'ag': 'en',
        'ai': 'en',
        'al': 'sq',
        'am': 'hy',
        'an': 'nl,en',
        'ao': 'pt',
        // 'aq': '',
        'ar': 'es',
        'as': 'en,sm',
        'at': 'de',
        'au': 'en',
        'aw': 'nl,pap',
        'ax': 'sv',
        'ba': 'bs,hr,sr',
        'bb': 'en',
        'bd': 'bn',
        'be': 'nl,fr,de',
        'bf': 'fr',
        'bh': 'ar',
        'bi': 'fr',
        'bj': 'fr',
        'bl': 'fr',
        'bm': 'en',
        'bn': 'ms',
        'bo': 'es,qu,ay',
        'br': 'pt',
        'bs': 'en',
        'bt': 'dz',
        'bv': 'no',
        'bw': 'en,tn',
        'by': 'be,ru',
        'bz': 'en',
        'ca': 'en,fr',
        'cc': 'en',
        'cd': 'fr',
        'cf': 'fr',
        'cg': 'fr',
        'ch': 'de,fr,it,rm',
        'ci': 'fr',
        'ck': 'en,rar',
        'cl': 'es',
        'cm': 'fr,en',
        'cn': 'zh',
        'co': 'es',
        'cr': 'es',
        'cu': 'es',
        'cv': 'pt',
        'cx': 'en',
        'cy': 'el,tr',
        'cz': 'cs',
        '// de': 'de',
        'dj': 'fr,ar,so',
        'dk': 'da',
        'dm': 'en',
        'do': 'es',
        'dz': 'ar',
        'ec': 'es',
        'ee': 'et',
        'eg': 'ar',
        'eh': 'ar,es,fr',
        'er': 'ti,ar,en',
        'es': 'ast,ca,es,eu,gl',
        'et': 'am,om',
        'fi': 'fi,sv,se',
        'fj': 'en',
        'fk': 'en',
        'fm': 'en',
        // 'fo': 'fo',
        // 'fr': 'fr',
        'ga': 'fr',
        'gb': 'en,ga,cy,gd,kw',
        'gd': 'en',
        'ge': 'ka',
        'gf': 'fr',
        'gg': 'en',
        'gh': 'en',
        'gi': 'en',
        'gl': 'kl,da',
        'gm': 'en',
        'gn': 'fr',
        'gp': 'fr',
        'gq': 'es,fr,pt',
        'gr': 'el',
        'gs': 'en',
        'gt': 'es',
        'gu': 'en,ch',
        'gw': 'pt',
        'gy': 'en',
        'hk': 'zh,en',
        'hm': 'en',
        'hn': 'es',
        // 'hr': 'hr',
        'ht': 'fr,ht',
        // 'hu': 'hu',
        // 'id': 'id',
        'ie': 'en,ga',
        'il': 'he',
        'im': 'en',
        'in': 'hi,en',
        'io': 'en',
        'iq': 'ar,ku',
        'ir': 'fa',
        // 'is': 'is',
        'it': 'it,de,fr',
        'je': 'en',
        'jm': 'en',
        'jo': 'ar',
        'jp': 'ja',
        'ke': 'sw,en',
        'kg': 'ky,ru',
        'kh': 'km',
        'ki': 'en',
        'km': 'ar,fr',
        'kn': 'en',
        'kp': 'ko',
        'kr': 'ko,en',
        'kw': 'ar',
        'ky': 'en',
        'kz': 'kk,ru',
        'la': 'lo',
        'lb': 'ar,fr',
        'lc': 'en',
        'li': 'de',
        'lk': 'si,ta',
        'lr': 'en',
        'ls': 'en,st',
        // 'lt': 'lt',
        'lu': 'lb,fr,de',
        // 'lv': 'lv',
        'ly': 'ar',
        'ma': 'ar',
        'mc': 'fr',
        'md': 'ru,uk,ro',
        'me': 'srp,sq,bs,hr,sr',
        'mf': 'fr',
        'mg': 'mg,fr',
        'mh': 'en,mh',
        // 'mk': 'mk',
        'ml': 'fr',
        'mm': 'my',
        // 'mn': 'mn',
        'mo': 'zh,pt',
        'mp': 'ch',
        'mq': 'fr',
        'mr': 'ar,fr',
        'ms': 'en',
        'mt': 'mt,en',
        'mu': 'mfe,fr,en',
        'mv': 'dv',
        'mw': 'en,ny',
        'mx': 'es',
        'my': 'ms',
        'mz': 'pt',
        'na': 'en,sf,de',
        'nc': 'fr',
        'ne': 'fr',
        'nf': 'en,pih',
        'ng': 'en',
        'ni': 'es',
        // 'nl': 'nl',
        'no': 'nb,nn,no,se',
        'np': 'ne',
        'nr': 'na,en',
        'nu': 'niu,en',
        'nz': 'mi,en',
        'om': 'ar',
        'pa': 'es',
        'pe': 'es',
        'pf': 'fr',
        'pg': 'en,tpi,ho',
        'ph': 'en,tl',
        'pk': 'en,ur',
        // 'pl': 'pl',
        'pm': 'fr',
        'pn': 'en,pih',
        'pr': 'es,en',
        'ps': 'ar,he',
        // 'pt': 'pt',
        'pw': 'en,pau,ja,sov,tox',
        'py': 'es,gn',
        'qa': 'ar',
        're': 'fr',
        // 'ro': 'ro',
        'rs': 'sr',
        // 'ru': 'ru',
        'rw': 'rw,fr,en',
        'sa': 'ar',
        'sb': 'en',
        'sc': 'fr,en,crs',
        'sd': 'ar,en',
        'se': 'sv',
        'sg': 'en,ms,zh,ta',
        'sh': 'en',
        'si': 'sl',
        'sj': 'no',
        // 'sk': 'sk',
        'sl': 'en',
        'sm': 'it',
        'sn': 'fr',
        'so': 'so,ar',
        'sr': 'nl',
        'st': 'pt',
        'ss': 'en',
        'sv': 'es',
        'sy': 'ar',
        'sz': 'en,ss',
        'tc': 'en',
        'td': 'fr,ar',
        'tf': 'fr',
        'tg': 'fr',
        // 'th': 'th',
        'tj': 'tg,ru',
        'tk': 'tkl,en,sm',
        'tl': 'pt,tet',
        'tm': 'tk',
        'tn': 'ar',
        'to': 'en',
        // 'tr': 'tr',
        'tt': 'en',
        'tv': 'en',
        'tw': 'zh',
        'tz': 'sw,en',
        'ua': 'uk',
        'ug': 'en,sw',
        'um': 'en',
        'us': 'en',
        'uy': 'es',
        'uz': 'uz,kaa',
        'va': 'it',
        'vc': 'en',
        've': 'es',
        'vg': 'en',
        'vi': 'en',
        'vn': 'vi',
        'vu': 'bi,en,fr',
        'wf': 'fr',
        'ws': 'sm,en',
        'ye': 'ar',
        'yt': 'fr',
        'za': 'zu,xh,af,st,tn,en',
        'zm': 'en',
        'zw': 'en,sn,nd ',
    };

    /*
    * Timezone city to country mapping, computed from https://data.iana.org/time-zones/data/zone.tab
    */

    private timeZoneCityToCountry: any = {
        'Abidjan': 'CI',
        'Accra': 'GH',
        'Adak': 'US',
        'Addis_Ababa': 'ET',
        'Adelaide': 'AU',
        'Aden': 'YE',
        'Algiers': 'DZ',
        'Almaty': 'KZ',
        'Amman': 'JO',
        'Amsterdam': 'NL',
        'Anadyr': 'RU',
        'Anchorage': 'US',
        'Andorra': 'AD',
        'Anguilla': 'AI',
        'Antananarivo': 'MG',
        'Antigua': 'AG',
        'Apia': 'WS',
        'Aqtau': 'KZ',
        'Aqtobe': 'KZ',
        'Araguaina': 'BR',
        'Aruba': 'AW',
        'Ashgabat': 'TM',
        'Asmara': 'ER',
        'Astrakhan': 'RU',
        'Asuncion': 'PY',
        'Athens': 'GR',
        'Atikokan': 'CA',
        'Atyrau': 'KZ',
        'Auckland': 'NZ',
        'Azores': 'PT',
        'Baghdad': 'IQ',
        'Bahia': 'BR',
        'Bahia_Banderas': 'MX',
        'Bahrain': 'BH',
        'Baku': 'AZ',
        'Bamako': 'ML',
        'Bangkok': 'TH',
        'Bangui': 'CF',
        'Banjul': 'GM',
        'Barbados': 'BB',
        'Barnaul': 'RU',
        'Beirut': 'LB',
        'Belem': 'BR',
        'Belgrade': 'RS',
        'Belize': 'BZ',
        'Berlin': 'DE',
        'Bermuda': 'BM',
        'Beulah': 'US',
        'Bishkek': 'KG',
        'Bissau': 'GW',
        'Blanc-Sablon': 'CA',
        'Blantyre': 'MW',
        'Boa_Vista': 'BR',
        'Bogota': 'CO',
        'Boise': 'US',
        'Bougainville': 'PG',
        'Bratislava': 'SK',
        'Brazzaville': 'CG',
        'Brisbane': 'AU',
        'Broken_Hill': 'AU',
        'Brunei': 'BN',
        'Brussels': 'BE',
        'Bucharest': 'RO',
        'Budapest': 'HU',
        'Buenos_Aires': 'AR',
        'Bujumbura': 'BI',
        'Busingen': 'DE',
        'Cairo': 'EG',
        'Cambridge_Bay': 'CA',
        'Campo_Grande': 'BR',
        'Canary': 'ES',
        'Cancun': 'MX',
        'Cape_Verde': 'CV',
        'Caracas': 'VE',
        'Casablanca': 'MA',
        'Casey': 'AQ',
        'Catamarca': 'AR',
        'Cayenne': 'GF',
        'Cayman': 'KY',
        'Center': 'US',
        'Ceuta': 'ES',
        'Chagos': 'IO',
        'Chatham': 'NZ',
        'Chicago': 'US',
        'Chihuahua': 'MX',
        'Chisinau': 'MD',
        'Chita': 'RU',
        'Christmas': 'CX',
        'Chuuk': 'FM',
        'Ciudad_Juarez': 'MX',
        'Cocos': 'CC',
        'Colombo': 'LK',
        'Comoro': 'KM',
        'Conakry': 'GN',
        'Copenhagen': 'DK',
        'Cordoba': 'AR',
        'Costa_Rica': 'CR',
        'Creston': 'CA',
        'Cuiaba': 'BR',
        'Curacao': 'CW',
        'Dakar': 'SN',
        'Damascus': 'SY',
        'Danmarkshavn': 'GL',
        'Dar_es_Salaam': 'TZ',
        'Darwin': 'AU',
        'Davis': 'AQ',
        'Dawson': 'CA',
        'Dawson_Creek': 'CA',
        'Denver': 'US',
        'Detroit': 'US',
        'Dhaka': 'BD',
        'Dili': 'TL',
        'Djibouti': 'DJ',
        'Dominica': 'DM',
        'Douala': 'CM',
        'Dubai': 'AE',
        'Dublin': 'IE',
        'DumontDUrville': 'AQ',
        'Dushanbe': 'TJ',
        'Easter': 'CL',
        'Edmonton': 'CA',
        'Efate': 'VU',
        'Eirunepe': 'BR',
        'El_Aaiun': 'EH',
        'El_Salvador': 'SV',
        'Eucla': 'AU',
        'Fakaofo': 'TK',
        'Famagusta': 'CY',
        'Faroe': 'FO',
        'Fiji': 'FJ',
        'Fort_Nelson': 'CA',
        'Fortaleza': 'BR',
        'Freetown': 'SL',
        'Funafuti': 'TV',
        'Gaborone': 'BW',
        'Galapagos': 'EC',
        'Gambier': 'PF',
        'Gaza': 'PS',
        'Gibraltar': 'GI',
        'Glace_Bay': 'CA',
        'Goose_Bay': 'CA',
        'Grand_Turk': 'TC',
        'Grenada': 'GD',
        'Guadalcanal': 'SB',
        'Guadeloupe': 'GP',
        'Guam': 'GU',
        'Guatemala': 'GT',
        'Guayaquil': 'EC',
        'Guernsey': 'GG',
        'Guyana': 'GY',
        'Halifax': 'CA',
        'Harare': 'ZW',
        'Havana': 'CU',
        'Hebron': 'PS',
        'Helsinki': 'FI',
        'Hermosillo': 'MX',
        'Ho_Chi_Minh': 'VN',
        'Hobart': 'AU',
        'Hong_Kong': 'HK',
        'Honolulu': 'US',
        'Hovd': 'MN',
        'Indianapolis': 'US',
        'Inuvik': 'CA',
        'Iqaluit': 'CA',
        'Irkutsk': 'RU',
        'Isle_of_Man': 'IM',
        'Istanbul': 'TR',
        'Jakarta': 'ID',
        'Jamaica': 'JM',
        'Jayapura': 'ID',
        'Jersey': 'JE',
        'Jerusalem': 'IL',
        'Johannesburg': 'ZA',
        'Juba': 'SS',
        'Jujuy': 'AR',
        'Juneau': 'US',
        'Kabul': 'AF',
        'Kaliningrad': 'RU',
        'Kamchatka': 'RU',
        'Kampala': 'UG',
        'Kanton': 'KI',
        'Karachi': 'PK',
        'Kathmandu': 'NP',
        'Kerguelen': 'TF',
        'Khandyga': 'RU',
        'Khartoum': 'SD',
        'Kigali': 'RW',
        'Kinshasa': 'CD',
        'Kiritimati': 'KI',
        'Kirov': 'RU',
        'Knox': 'US',
        'Kolkata': 'IN',
        'Kosrae': 'FM',
        'Kralendijk': 'BQ',
        'Krasnoyarsk': 'RU',
        'Kuala_Lumpur': 'MY',
        'Kuching': 'MY',
        'Kuwait': 'KW',
        'Kwajalein': 'MH',
        'Kyiv': 'UA',
        'La_Paz': 'BO',
        'La_Rioja': 'AR',
        'Lagos': 'NG',
        'Libreville': 'GA',
        'Lima': 'PE',
        'Lindeman': 'AU',
        'Lisbon': 'PT',
        'Ljubljana': 'SI',
        'Lome': 'TG',
        'London': 'GB',
        'Longyearbyen': 'SJ',
        'Lord_Howe': 'AU',
        'Los_Angeles': 'US',
        'Louisville': 'US',
        'Lower_Princes': 'SX',
        'Luanda': 'AO',
        'Lubumbashi': 'CD',
        'Lusaka': 'ZM',
        'Luxembourg': 'LU',
        'Macau': 'MO',
        'Maceio': 'BR',
        'Macquarie': 'AU',
        'Madeira': 'PT',
        'Madrid': 'ES',
        'Magadan': 'RU',
        'Mahe': 'SC',
        'Majuro': 'MH',
        'Makassar': 'ID',
        'Malabo': 'GQ',
        'Maldives': 'MV',
        'Malta': 'MT',
        'Managua': 'NI',
        'Manaus': 'BR',
        'Manila': 'PH',
        'Maputo': 'MZ',
        'Marengo': 'US',
        'Mariehamn': 'AX',
        'Marigot': 'MF',
        'Marquesas': 'PF',
        'Martinique': 'MQ',
        'Maseru': 'LS',
        'Matamoros': 'MX',
        'Mauritius': 'MU',
        'Mawson': 'AQ',
        'Mayotte': 'YT',
        'Mazatlan': 'MX',
        'Mbabane': 'SZ',
        'McMurdo': 'AQ',
        'Melbourne': 'AU',
        'Mendoza': 'AR',
        'Menominee': 'US',
        'Merida': 'MX',
        'Metlakatla': 'US',
        'Mexico_City': 'MX',
        'Midway': 'UM',
        'Minsk': 'BY',
        'Miquelon': 'PM',
        'Mogadishu': 'SO',
        'Monaco': 'MC',
        'Moncton': 'CA',
        'Monrovia': 'LR',
        'Monterrey': 'MX',
        'Montevideo': 'UY',
        'Monticello': 'US',
        'Montserrat': 'MS',
        'Moscow': 'RU',
        'Muscat': 'OM',
        'Nairobi': 'KE',
        'Nassau': 'BS',
        'Nauru': 'NR',
        'Ndjamena': 'TD',
        'New_Salem': 'US',
        'New_York': 'US',
        'Niamey': 'NE',
        'Nicosia': 'CY',
        'Niue': 'NU',
        'Nome': 'US',
        'Norfolk': 'NF',
        'Noronha': 'BR',
        'Nouakchott': 'MR',
        'Noumea': 'NC',
        'Novokuznetsk': 'RU',
        'Novosibirsk': 'RU',
        'Nuuk': 'GL',
        'Ojinaga': 'MX',
        'Omsk': 'RU',
        'Oral': 'KZ',
        'Oslo': 'NO',
        'Ouagadougou': 'BF',
        'Pago_Pago': 'AS',
        'Palau': 'PW',
        'Palmer': 'AQ',
        'Panama': 'PA',
        'Paramaribo': 'SR',
        'Paris': 'FR',
        'Perth': 'AU',
        'Petersburg': 'US',
        'Phnom_Penh': 'KH',
        'Phoenix': 'US',
        'Pitcairn': 'PN',
        'Podgorica': 'ME',
        'Pohnpei': 'FM',
        'Pontianak': 'ID',
        'Port-au-Prince': 'HT',
        'Port_Moresby': 'PG',
        'Port_of_Spain': 'TT',
        'Porto-Novo': 'BJ',
        'Porto_Velho': 'BR',
        'Prague': 'CZ',
        'Puerto_Rico': 'PR',
        'Punta_Arenas': 'CL',
        'Pyongyang': 'KP',
        'Qatar': 'QA',
        'Qostanay': 'KZ',
        'Qyzylorda': 'KZ',
        'Rankin_Inlet': 'CA',
        'Rarotonga': 'CK',
        'Recife': 'BR',
        'Regina': 'CA',
        'Resolute': 'CA',
        'Reunion': 'RE',
        'Reykjavik': 'IS',
        'Riga': 'LV',
        'Rio_Branco': 'BR',
        'Rio_Gallegos': 'AR',
        'Riyadh': 'SA',
        'Rome': 'IT',
        'Rothera': 'AQ',
        'Saipan': 'MP',
        'Sakhalin': 'RU',
        'Salta': 'AR',
        'Samara': 'RU',
        'Samarkand': 'UZ',
        'San_Juan': 'AR',
        'San_Luis': 'AR',
        'San_Marino': 'SM',
        'Santarem': 'BR',
        'Santiago': 'CL',
        'Santo_Domingo': 'DO',
        'Sao_Paulo': 'BR',
        'Sao_Tome': 'ST',
        'Sarajevo': 'BA',
        'Saratov': 'RU',
        'Scoresbysund': 'GL',
        'Seoul': 'KR',
        'Shanghai': 'CN',
        'Simferopol': 'UA',
        'Singapore': 'SG',
        'Sitka': 'US',
        'Skopje': 'MK',
        'Sofia': 'BG',
        'South_Georgia': 'GS',
        'Srednekolymsk': 'RU',
        'St_Barthelemy': 'BL',
        'St_Helena': 'SH',
        'St_Johns': 'CA',
        'St_Kitts': 'KN',
        'St_Lucia': 'LC',
        'St_Thomas': 'VI',
        'St_Vincent': 'VC',
        'Stanley': 'FK',
        'Stockholm': 'SE',
        'Swift_Current': 'CA',
        'Sydney': 'AU',
        'Syowa': 'AQ',
        'Tahiti': 'PF',
        'Taipei': 'TW',
        'Tallinn': 'EE',
        'Tarawa': 'KI',
        'Tashkent': 'UZ',
        'Tbilisi': 'GE',
        'Tegucigalpa': 'HN',
        'Tehran': 'IR',
        'Tell_City': 'US',
        'Thimphu': 'BT',
        'Thule': 'GL',
        'Tijuana': 'MX',
        'Tirane': 'AL',
        'Tokyo': 'JP',
        'Tomsk': 'RU',
        'Tongatapu': 'TO',
        'Toronto': 'CA',
        'Tortola': 'VG',
        'Tripoli': 'LY',
        'Troll': 'AQ',
        'Tucuman': 'AR',
        'Tunis': 'TN',
        'Ulaanbaatar': 'MN',
        'Ulyanovsk': 'RU',
        'Urumqi': 'CN',
        'Ushuaia': 'AR',
        'Ust-Nera': 'RU',
        'Vaduz': 'LI',
        'Vancouver': 'CA',
        'Vatican': 'VA',
        'Vevay': 'US',
        'Vienna': 'AT',
        'Vientiane': 'LA',
        'Vilnius': 'LT',
        'Vincennes': 'US',
        'Vladivostok': 'RU',
        'Volgograd': 'RU',
        'Vostok': 'AQ',
        'Wake': 'UM',
        'Wallis': 'WF',
        'Warsaw': 'PL',
        'Whitehorse': 'CA',
        'Winamac': 'US',
        'Windhoek': 'NA',
        'Winnipeg': 'CA',
        'Yakutat': 'US',
        'Yakutsk': 'RU',
        'Yangon': 'MM',
        'Yekaterinburg': 'RU',
        'Yerevan': 'AM',
        'Zagreb': 'HR',
        'Zurich': 'CH'
    };

    /* ****************************************************** */
    /* * LIFE CYCLE STUFF                                   * */
    /* ****************************************************** */
    public static getInstance() {
        return Service.create(COUNTRY_SVC, CountryService);
    }

    public static build() {
        return new CountryService();
    }

    private constructor() { super(); }

    public async start() {
        this.logger.info("");
        this.logger.info("[countryService] === STARTING ===");
        this.portalURL = `${config.restServerUrl}/api/rainbow/enduser/v1.0/`;

        try {
            await this.initializeCountries();
        }
        catch (error) { this.logger.info("[countryService] === warning === " + error.message); }
        this.logger.info("[countryService] === STARTED  === " + this.countries.length + " countries");
        this.logger.info("");
    }

    public async stop() {
        this.logger.info("[countryService] STOPPED");
    }


    /********************************************************/
    /** PUBLIC                                             **/
    /********************************************************/
    /*
     * Get a countries list ready for <drop-list> tag
     */
    public getCountries(): Country[] {
        const countries = this.countries.map((country: Country) => {
            const label = this.getCountryLabel(country["alpha-2"]);
            if (label) {
                const name = this.i18n.translate(label);
                if (name && name !== label) { country.name = name; }
            }
            return country;
        });
        countries.sort((country1: Country, country2: Country) => { return country1.name.localeCompare(country2.name, this.i18n.getCurrentLanguage()); });
        return countries;
    }

    /*
    * Get an american states list (ready for <select> tag)
    */
    public getCountryStates(country: any): any {
        if (country && country["alpha-3"] === "USA") { return this.statesOfAmerica; }
        if (country && country["alpha-3"] === "CAN") { return this.statesOfCanada; }
        return {};
    }

    /*
    * Get a country for a given alpha-3 country code
    */
    public getCountry(countryCodeAlpha3: string, defaulted: any = null): Country {
        if (!countryCodeAlpha3) { return defaulted ? this.getDefaultCountry() : null; }
        const countries = this.countries.filter((country) => { return country["alpha-3"] === countryCodeAlpha3; });
        return countries.length > 0 ? countries[0] : null;
    }

    public getCountryFromAlpha2(countryCodeAlpha2: string): Country {
        if (!countryCodeAlpha2) { return null; }
        return this.countries.find((country) => { return country["alpha-2"] === countryCodeAlpha2; });
    }

    public getDefaultCountry(): Country {
        const countries = this.countries.filter((country) => { return country.default === true; });
        return countries.length > 0 ? countries[0] : this.countries[0];
    }

    public getCountryName(countryCode: string): string {
        const country = this.getCountry(countryCode);
        return country ? this.getCountry(countryCode).name : null;
    }

    public getCountryCode(country: Country): string {
        return country ? country["alpha-3"] : null;
    }

    public getCountryDataFromName(countryName: string): Country {
        if (!countryName) { return null; }
        const countries = this.countries.filter((country) => { return country["name"] === countryName; });
        return countries.length > 0 ? countries[0] : null;
    }

    public getCountryCodeFromName(countryName: string): string {
        const country = this.getCountryDataFromName(countryName);
        return country ? country["alpha-3"] : null;
    }

    public getStateCodeFromName(countryName: string, stateName: string): string {
        const country = this.getCountryDataFromName(countryName);

        if (country && country["alpha-3"] === "USA") {
            for (const [code, name] of Object.entries(this.statesOfAmerica)) {
                if (stateName === name) {
                    return code;
                }
            }
        }

        if (country && country["alpha-3"] === "CAN") {
            for (const [code, name] of Object.entries(this.statesOfCanada)) {
                if (stateName === name) {
                    return code;
                }
            }
        }
        return null;
    }


    public getStateName(country: string, state: string): string {
        if (!country) return '';
        if (!state) return '';
        if (country === "USA") { return this.statesOfAmerica[state] as string; }
        if (country === "CAN") { return this.statesOfCanada[state] as string; }
        return '';
    }

    public getDefaultState(country: any): string {
        if (country && country["alpha-3"] === "USA") { return "AL"; }
        if (country && country["alpha-3"] === "CAN") { return "AB"; }
        return null;
    }

    public getAlpha2Code(alpha3Code: string): string {
        if (!alpha3Code) { return null; }
        const countries = this.countries.filter((country) => { return country["alpha-3"] === alpha3Code; });
        return countries.length > 0 ? (countries[0]["alpha-2"] as string) : null;
    }

    public getAlpha3Code(alpha2Code: string): string {
        if (!alpha2Code) { return null; }
        const foundCountry = this.countries.find((country) => { return country["alpha-2"] === alpha2Code; });
        return foundCountry ? (foundCountry["alpha-3"] as string) : null;
    }

    public getCountryLabel(alphaCode: string): string {
        let alpha2Code: string = null;
        if (alphaCode.length === 3) { alpha2Code = this.getAlpha2Code(alphaCode); } // alpha-3 code
        else { alpha2Code = alphaCode; } // alpha-2 code
        if (alpha2Code) { return "country" + alpha2Code; }
        return null;
    }

    public getDataCenterLabel(datacenterLocation, companyCountry) {
        // By default, take the geographical region (zone) where the data center is located
        let label = this.getRegionLabel(datacenterLocation.name);

        if (datacenterLocation.country === companyCountry) {
            // Take exact data center location when the company is nearby
            label = this.getCountryLabel(datacenterLocation.country);
        }
        else {
            // Otherwise, let's be vague about the exact region (ex. Canada (North-America) => America)
            const datacenter = this.datacenters.find((dc) => { return dc["alpha-3"] === datacenterLocation.country; });
            if (datacenter) { label = this.getRegionLabel(datacenter.region); }
        }
        return label;
    }

    public getRegionLabel(regionName: string): string { return regionName; }

    public getInternationalCallingCode(countryAlpha2Code: string): string {
        if (!countryAlpha2Code) { return undefined; }
        const countryCode: string = countryAlpha2Code.toUpperCase();
        return this.countryToInternationalCallingCodeMapping[countryCode] as string;
    }

    public mapCountryToLanguages(countryAlpha2Code: string): string[] {
        // This method may return several languages
        if (!countryAlpha2Code) { return undefined; }
        const countryCode: string = countryAlpha2Code.toLowerCase();
        if (typeof this.countryToLanguageMapping[countryCode] !== 'undefined') { return this.countryToLanguageMapping[countryCode].split(",") as string[]; }
        return [countryCode];
    }

    public initializeCountriesWithoutAuthToken() {
        return this.initializeCountries(false); // without auth token, for passwordless authent by phone login
    }

    /********************************************************/
    /** PRIVATE                                            **/
    /********************************************************/

    private async initializeCountries(withAuthToken: boolean = true) {
        const serverAvailableCountries = await this.getAvailableCountries(withAuthToken);
        this.countries = serverAvailableCountries.map((serverCountry: any) => {
            const country: Country = { "name": serverCountry.fullname, "alpha-3": serverCountry.isoAlpha3Code, "alpha-2": serverCountry.isoAlpha2Code };
            if (serverCountry.isoAlpha3Code === "FRA") { country.default = true; }
            return country;
        });
    }

    private async getAvailableCountries(withAuthToken: boolean = true): Promise<any> {
        try {
            const headers = withAuthToken ? this.authService.getRequestHeader() : { 'Accept': 'application/json' };
            const response: Response = await fetch(`${config.restServerUrl}/api/rainbow/enduser/v1.0/countries`, { method: 'GET', headers });
            // Note: this method may be called by loginpage for passwordless authent by number;
            // in this case, this service is not yet started and thus portalURL property is not yet initialized:
            // that'as why we use here config.serverUrl... instead of portalURL property in the url
            if (!response.ok) { throw (response); }
            return (await response.json()).data;
        }
        catch (error) {
            const errorInfo = await this.errorHelperService.getErrorInfo(error, 'getAvailableCountries');
            this.logger.error(`[countryService] ${errorInfo.message}`);
            throw errorInfo.error;
        }
    }

    /*
    * Get a country from computer's timezone
    * Used for passwordless authent when login by phone number
    */
    public getCountryFromComputerTimezone(): Country {
        if (Intl) {
            const computerTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const tzArr = computerTimeZone?.split("/");
            if (tzArr.length) {
                const tzCity: string = tzArr[tzArr.length - 1];
                const countryCodeAlpha2: string = this.timeZoneCityToCountry[tzCity];
                return this.getCountryFromAlpha2(countryCodeAlpha2);
            }
        }
        return undefined;
    }
}
